module.exports = __webpack_public_path__ + "static/media/agent.7aa82c6e.jpg";